import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

import { Row, Col, CardBody, Card, Alert, Container, Form, Input, FormFeedback, Label, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import withRouter from "components/Common/withRouter";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

//Social Media Imports
import { GoogleLogin } from "react-google-login";
// import TwitterLogin from "react-twitter-auth"
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";

// actions
import { loginUser, socialLogin } from "../../store/actions";

// import images
import profile from "assets/images/profile-img.png";
import logo from "assets/images/logo.svg";

//Import config
import { facebook, google } from "../../config";
import { loginUserApi, sendEmailOtp, verifyEmailOtp } from "service/api";


const Login = props => {

  //meta title
  document.title = "Login | Ai in realstate";
  const [otpModal, setOtpModal] = useState(false);
  const [otp, setOtp] = useState("");
  const [timer, setTimer] = useState(60);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const setLoginSession = (data) => {
    localStorage.setItem("token", data.token);
    localStorage.setItem("user", JSON.stringify(data.user));
    localStorage.setItem("authUser", JSON.stringify(data.user));
  };

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: "" || '',
      password: "" || '',
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email"),
      password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: async (values) => {
      console.log("FORM SUBMIT VALUES:", values);

      try {
        const response = await loginUserApi(values);
        console.log("LOGIN RESPONSE:", response);

        if (response.data.success) {
          setLoginSession(response.data);

          // alert("Login successful!");
          navigate("/");
        } else {
          alert(response.data.message || "Login failed");
        }
      } catch (error) {
        console.log("LOGIN ERROR FULL:", error);

        alert(
          error.message ||
          "API not reachable"
        );
      }
    }


  });

  const { error } = useSelector(state => ({
    error: state.Login.error,
  }));

  const signIn = (res, type) => {
    if (type === "google" && res) {
      const postData = {
        name: res.profileObj.name,
        email: res.profileObj.email,
        token: res.tokenObj.access_token,
        idToken: res.tokenId,
      };
      dispatch(socialLogin(postData, props.router.navigate, type));
    } else if (type === "facebook" && res) {
      const postData = {
        name: res.name,
        email: res.email,
        token: res.accessToken,
        idToken: res.tokenId,
      };
      dispatch(socialLogin(postData, props.router.navigate, type));
    }
  };

  //handleGoogleLoginResponse
  const googleResponse = response => {
    signIn(response, "google");
  };

  //handleTwitterLoginResponse
  // const twitterResponse = e => {}

  //handleFacebookLoginResponse
  const facebookResponse = response => {
    signIn(response, "facebook");
  };

  useEffect(() => {
    let interval;
    if (otpModal && timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }

    if (timer === 0) {
      setOtpModal(false);
      setOtp("");
      setTimer(60);
      alert("OTP expired. Please try again.");
    }

    return () => clearInterval(interval);
  }, [otpModal, timer]);


  return (
    <React.Fragment>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-light">
          <i className="bx bx-home h2" />
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card
                className="overflow-hidden"
                style={{
                  background: "rgba(255, 255, 255, 0.1)", // Semi-transparent white background
                  border: "1px solid rgba(255, 255, 255, 0.2)", // Light border for definition
                  borderRadius: "12px", // Slightly smaller rounded corners
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)", // Subtle shadow for compact design
                  backdropFilter: "blur(8px)", // Blurred background for depth
                  padding: "12px", // Reduced padding for a compact layout
                  color: "#ffffff", // White text color for readability
                }}
              >
                <div className="bg-primary bg-soft">
                  <Row>
                    <Col xs={8}>
                      <div className="text-primary p-3">
                        <h5 className="text-white">Welcome Back!</h5>
                        <p className="text-white mb-0" style={{ fontSize: "0.9rem" }}>
                          Sign in to continue to Aiinrealestate.
                        </p>
                      </div>
                    </Col>
                    <Col xs={4} className="align-self-end text-center">
                      <img
                        src={profile}
                        alt=""
                        className="img-fluid"
                        style={{
                          maxWidth: "100px", // Reduced image size
                          borderRadius: "50%", // Circular profile image
                        }}
                      />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-1">
                  <div>
                    <Link to="/" className="logo-light-element">
                      <div className="avatar-sm profile-user-wid mb-3">
                        <span
                          className="avatar-title rounded-circle"
                          style={{
                            background: "rgba(255, 255, 255, 0.2)", // Semi-transparent circle
                          }}
                        >
                          <img
                            src={logo}
                            alt=""
                            className="rounded-circle"
                            height="24" // Reduced logo size
                            style={{ filter: "brightness(0) invert(1)" }} // Adjusted for dark background
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-1">
                    <Form
                      className="form-horizontal"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      {error ? <Alert color="danger">{error}</Alert> : null}

                      <div className="mb-2">
                        <Label className="form-label" style={{ color: "#ffffff", fontSize: "0.85rem" }}>
                          Email
                        </Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Enter email"
                          type="email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          style={{
                            background: "rgba(255, 255, 255, 0.1)",
                            color: "#ffffff",
                            border: "1px solid rgba(255, 255, 255, 0.2)",
                            fontSize: "0.9rem",
                            padding: "6px 10px", // Reduced padding for compact input
                          }}
                        />
                      </div>

                      <div className="mb-2">
                        <Label className="form-label" style={{ color: "#ffffff", fontSize: "0.85rem" }}>
                          Password
                        </Label>
                        <Input
                          name="password"
                          value={validation.values.password || ""}
                          type="password"
                          placeholder="Enter Password"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          style={{
                            background: "rgba(255, 255, 255, 0.1)",
                            color: "#ffffff",
                            border: "1px solid rgba(255, 255, 255, 0.2)",
                            fontSize: "0.9rem",
                            padding: "6px 10px", // Reduced padding for compact input
                          }}
                        />
                      </div>

                      <div className="form-check mb-2">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="customControlInline"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="customControlInline"
                          style={{ color: "#ffffff", fontSize: "0.85rem" }}
                        >
                          Remember me
                        </label>
                      </div>

                      <div className="mt-3 d-grid">
                        <button
                          className="btn btn-primary btn-block"
                          type="submit"
                          style={{
                            backgroundColor: "#6f42c1", // Matches the header color
                            border: "none",
                            fontSize: "14px", // Reduced font size
                            borderRadius: "6px",
                            transition: "background-color 0.3s ease",
                            padding: "6px 12px", // Compact button size
                          }}
                          onMouseOver={(e) => (e.target.style.backgroundColor = "#5a35a5")}
                          onMouseOut={(e) => (e.target.style.backgroundColor = "#6f42c1")}
                        >
                          Log In
                        </button>
                        <button
                          type="button"
                          className="btn btn-outline-light w-100 mt-2"
                          onClick={async () => {
                            if (!validation.values.email) {
                              alert("Please enter your email first");
                              return;
                            }

                            try {
                              await sendEmailOtp({ email: validation.values.email });
                              alert("OTP sent to your email");
                              setOtpModal(true);
                              setTimer(60);
                            } catch (err) {
                              alert("Failed to send OTP");
                            }
                          }}
                        >
                          Login with Email OTP
                        </button>

                      </div>

                    </Form>
                  </div>
                </CardBody>
              </Card>



              <div
                className="mt-5 text-center"
                style={{ color: "#ffffff" }} // Sets text color to white for the entire block
              >
                <p>
                  Don&#39;t have an account ?{" "}
                  <Link
                    to="/register"
                    className="fw-medium"
                    style={{
                      color: "#ffffff", // White text color
                      textDecoration: "underline", // Underline for a clear link appearance
                      fontWeight: "bold", // Make the link text bold
                      transition: "color 0.3s ease", // Smooth hover transition
                    }}
                    onMouseOver={(e) => (e.target.style.color = "#ffc107")} // Change color on hover (yellow)
                    onMouseOut={(e) => (e.target.style.color = "#ffffff")} // Reset color on hover out
                  >
                    Signup now
                  </Link>
                </p>
                <p>
                  © {new Date().getFullYear()} Aiinrealestate. Crafted with{" "}
                  <i className="mdi mdi-heart text-danger" /> by Vivek
                </p>
              </div>

            </Col>
          </Row>
        </Container>
      </div>
      <Modal isOpen={otpModal} centered backdrop="static">
        <ModalHeader
          style={{
            background: "#6f42c1",
            color: "#fff",
            borderBottom: "none"
          }}
        >
          Enter OTP
        </ModalHeader>

        <ModalBody
          style={{
            background: "rgba(0,0,0,0.9)",
            color: "#fff"
          }}
        >
          <p style={{ textAlign: "center" }}>
            OTP sent to <b>{validation.values.email}</b>
          </p>

          <p style={{ textAlign: "center", color: "#ffc107" }}>
            Time remaining: {timer}s
          </p>

          <Input
            type="text"
            maxLength={6}
            placeholder="Enter OTP"
            value={otp}
            onChange={(e) => setOtp(e.target.value.replace(/[^0-9]/g, ""))}
            style={{
              textAlign: "center",
              fontSize: "20px",
              letterSpacing: "6px",
              background: "rgba(255,255,255,0.1)",
              color: "#fff",
              border: "1px solid rgba(255,255,255,0.3)"
            }}
          />
        </ModalBody>

        <ModalFooter
          style={{
            background: "rgba(0,0,0,0.9)",
            borderTop: "none"
          }}
        >
          <button
            className="btn btn-success w-100"
            onClick={async () => {
              try {
                const response = await verifyEmailOtp({
                  email: validation.values.email,
                  otp
                });

                if (response.data.success) {
                  setLoginSession(response.data);
                  // alert("Login successful!");
                  setOtpModal(false);
                  navigate("/");
                } else {
                  alert(response.data.message);
                }
              } catch {
                alert("Invalid OTP");
              }
            }}
          >
            Verify & Login
          </button>
        </ModalFooter>
      </Modal>

    </React.Fragment>
  );
};

export default withRouter(Login);

Login.propTypes = {
  history: PropTypes.object,
};
